import {Contract} from "@ethersproject/contracts";
import {ERC20ABI} from "./abi/ERC20ABI";
import {Web3Provider} from "@ethersproject/providers";
import {PhenomCampaignABI} from "./abi/PhenomCampaignABI";
import {ERC20} from "./contracts/erc20";
import {PhenomCampaign} from "./contracts/PhenomCampaign";
import {BigNumber, ethers} from "ethers";

export enum Phase {
    SEED,
    PRIVATE,
    COMMUNITY_SALE,
    // COMMUNITY_SALE_1,
    // COMMUNITY_SALE_2,
    // COMMUNITY_SALE_3,


    FUNDING_TEAM,
    ADVISORS,
    MARKETING,
    DEVELOPMENT,

    PUBLIC
}

export function phaseName(phase: Phase) {
    switch (phase) {
        case Phase.SEED: return '1. Seed Round'
        case Phase.PRIVATE: return '2. Private Round'
        case Phase.COMMUNITY_SALE: return '3. Community Sale'
        // case Phase.COMMUNITY_SALE_1: return '3. Community Sale 1'
        // case Phase.COMMUNITY_SALE_2: return '4. Community Sale 2'
        // case Phase.COMMUNITY_SALE_3: return '5. Community Sale 3'
        case Phase.FUNDING_TEAM: return '4. Funding Team'
        case Phase.ADVISORS: return '5. Advisors'
        case Phase.MARKETING: return '6. Marketing'
        case Phase.DEVELOPMENT: return '7. Development'
        default: return phase.toString()
    }
}

export const goerliChainId = 5
export const bscChainId = 56
export const currentChainId = bscChainId

const phetaTokenAddress = {
    [goerliChainId]: '0x82144D798FDa1e2dB3CffF445A111731A8418301',
    [bscChainId]: '0x49A94D2820F9CAA73CC80878b014Ca31a4FF1e36',
}
export const campaignContractAddress = {
    [goerliChainId]: '0x93Be2391f21f700825Aa18704b5346Ad24cFE114',
    [bscChainId]: '0x0808C18478a7016daf240df3f1882D44d20D0EF1',
}
const busdContractAddress = {
    [goerliChainId]: '0xb750A8f6591cE0258894c1a9875853BdaC37d0A8',
    [bscChainId]: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
}

let _campaignContract: PhenomCampaign

export async function getCampaignContract(library: Web3Provider): Promise<PhenomCampaign> {
    if (!_campaignContract) {
        const contract = new Contract(
            campaignContractAddress[currentChainId],
            PhenomCampaignABI,
            library.getSigner()
        )
        await contract.deployed()
        _campaignContract = contract as unknown as PhenomCampaign
    }
    return _campaignContract
}

let _busdContract: ERC20

export async function getBusdContract(library: Web3Provider): Promise<ERC20> {
    if (!_busdContract) {
        const contract = new Contract(
            busdContractAddress[currentChainId],
            ERC20ABI,
            library.getSigner()
        )
        await contract.deployed()
        _busdContract = contract as unknown as ERC20
    }
    return _busdContract
}

let _phetaTokenContract: ERC20

export async function getPhetaTokenContract(library: Web3Provider): Promise<ERC20> {
    if (!_phetaTokenContract) {
        const contract = new Contract(
            phetaTokenAddress[currentChainId],
            ERC20ABI,
            library.getSigner()
        )
        await contract.deployed()
        _phetaTokenContract = contract as unknown as ERC20
    }
    return _phetaTokenContract
}

export function prettyPrintBigNumber(bn: BigNumber) {
    if (bn === undefined) {
        return undefined
    }

    if (bn.isZero()) {
        return '0'
    }
    // if (bn.lt('100000000000000000')) {
    //     return '<0.1'
    // }
    const withoutFraction = Math.round(bn.div('1000000000000000000').toNumber())
    const fraction = bn.sub(BigNumber.from(withoutFraction).mul('1000000000000000000'))
    const formatted = (fraction.isZero() ? ethers.utils.formatEther(bn) : withoutFraction.toString())
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        .replace("000 000.0", 'kk')
        .replace("000.0", 'k')
        .replace(RegExp("\\.0$"), '')

    if (fraction.isZero()) {
        return formatted
    } else {
        return `~${formatted}`
    }
}

export async function addPhetaToken(phetaTokenContract: ERC20, account: string) {
    const phetaBalance = await phetaTokenContract.balanceOf(account)

    if (phetaBalance.isZero()) {
        const ethereum = window['ethereum']
        try {
            const wasAdded = await ethereum.request({
                method: 'wallet_watchAsset',
                params: {
                    type: 'ERC20',
                    options: {
                        address: phetaTokenAddress[currentChainId],
                        symbol: "PHETA", // A ticker symbol or shorthand, up to 5 chars.
                        decimals: 18,
                        image: 'https://user-images.githubusercontent.com/1183619/167500553-fd199209-cf7c-44a2-80fd-96f7d0ed247c.png' // A string url of the token logo
                    }
                }
            })

            if (wasAdded) {
                console.log('PHETA Token added');
            } else {
                console.warn('PHETA Token not added');
            }
        } catch (error) {
            console.error(error);
        }
    }
}

export async function getInvestedAmount(contract: PhenomCampaign, account: string) {
    let total = BigNumber.from(0)
    for(let phase = 0; phase <= Phase.PUBLIC; phase++) {
        const invested = await contract.getInvestedAmountByPhaseAndInvestor(phase, account);
        total = total.add(invested)
    }
    return total
}